/*
 * @Author:
 * @Date: 2023-07-08 11:27:36
 * @Description: 请填写简介
 */
import { lang } from '@public/utils/filters'
export default {
  // 转单责任方
  transferOption: [
    { value: 1, label: lang('总部工单组'), name: '总部工单组' },
    { value: 2, label: lang('始发网点'), name: '始发网点' },
    { value: 3, label: lang('最新路由节点'), name: '最新路由节点' },
    { value: 4, label: lang('无转单对象'), name: '无转单对象' },
    { value: 5, label: lang('总部理赔组'), name: '总部理赔组' }
  ],
  // 普通工单来源
  W_workOrderSource: [
    { value: 1, label: lang('网点组'), name: lang('网点组') },
    { value: 2, label: lang('代理组'), name: lang('代理组') },
    { value: 3, label: lang('总部组'), name: lang('总部组') },
    { value: 6, label: lang('总部理赔组'), name: lang('总部理赔组') }
  ],
  // 录入组别
  workOrderRecordGroup: [
    { value: 1, label: lang('电话组'), name: lang('电话组') },
    { value: 2, label: lang('在线组'), name: lang('在线组') }
  ],
  // 录入组别
  workOrderRecordGroupBs: [
    { value: 1, label: lang('电话组'), name: lang('电话组') },
    { value: 2, label: lang('在线组'), name: lang('在线组') },
    { value: 3, label: lang('百世组'), name: lang('百世组') },
    { value: 4, label: lang('robot'), name: lang('robot') },
    { value: 5, label: lang('微信小程序'), name: lang('微信小程序') },
    { value: 6, label: lang('舆情组'), name: lang('舆情组') },
    { value: 7, label: lang('vip大客户'), name: lang('vip大客户') },
    { value: 8, label: lang('工单组-导入'), name: lang('工单组-导入') }
  ],
  // 处理工单选项
  W_handleType: [
    { value: 1, label: lang('关闭'), name: '关闭' },
    { value: 2, label: lang('继续处理'), name: '继续处理' },
    { value: 3, label: lang('升级'), name: '升级' }
  ],
  // 响应状态
  W_responseState: [
    { value: 1, label: lang('及时响应'), name: '及时响应' },
    { value: 2, label: lang('超时响应'), name: '超时响应' },
    { value: 3, label: lang('尚未响应'), name: '尚未响应' }
  ],
    // 催单原因
  urgeReason: [
    { value: 1, label: lang('无人回复'), name: '无人回复' },
    { value: 2, label: lang('虚假回复'), name: '虚假回复' },
    { value: 3, label: lang('回复结果不满意'), name: '回复结果不满意' }
  ],
  SEX: [
    { label: lang('先生'), value: 1 },
    { label: lang('女士'), value: 2 }
  ],
  // 收寄件人类型
  C_receiptType: [
    { value: 1, label: lang('寄件人') },
    { value: 2, label: lang('收件人') },
    { value: 3, label: lang('其他') }
  ],
  memberTypeDict: [
    {
      label: '会员',
      value: 1
    },
    {
      label: '非会员',
      value: 2
    }
  ],
}
